"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgCurbsideDropoff = function SvgCurbsideDropoff(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M986.5 570.6h-37.7l-22.9-99.8c-10.9-47.2-50.8-80.2-96.9-80.2H469.7c-46.2 0-86 33-96.9 80.2l-23 99.8h-37.6c-20.7 0-37.5 16.8-37.5 37.5v45c0 20.7 16.8 37.5 37.5 37.5h7.5V833c0 15.1 9.1 28.2 22.4 34v43.5c0 9.1 2.4 17.6 6.7 25h-74.1V923c0-47.7-38.4-86.7-86-87.5V404.7h22.9c47.4 0 86-38.9 86-86.7V100.4c0-47.8-38.6-86.7-86-86.7H85.9C38.5 13.6 0 52.5 0 100.4V318c0 47.8 38.5 86.7 85.9 86.7h27.9v430.7H37.5C16.8 835.4 0 852.3 0 872.9c0 20.7 16.8 37.5 37.5 37.5h149.9c6.9 0 12.5 5.6 12.5 12.5v50c0 20.7 16.8 37.5 37.5 37.5h699.3c20.7 0 37.5-16.8 37.5-37.5 0-16.4-10.6-30.5-25.4-35.5 5-7.8 7.9-17 7.9-27v-43.5c13.3-5.8 22.4-18.9 22.4-34V690.5h7.5c20.7 0 37.5-16.8 37.5-37.5v-45c-.1-20.6-16.9-37.4-37.6-37.4zm-79.9 377.3zm-100.7-10.2H511.2c4.2-7.3 6.6-15.8 6.6-24.8v-39.8h281.5v39.8c0 9 2.4 17.4 6.6 24.8zm43 12.5zM436 576.4l19-86.4c3-13.5 12.5-23 23.3-23H832c10.8 0 20.3 9.5 23.3 23l18.9 86.4H436zm474.4 67.9v144.4H405.7V644.3h504.7zM392.1 947.9zM216.8 334H85.6c-7.1 0-12.9-5.7-12.9-12.7V99c0-7 5.8-12.7 12.9-12.7h131.2c7.2 0 13 5.7 13 12.7v222.3c0 7-5.8 12.7-13 12.7zm225.3 388.3c0-31.6 25.7-57.3 57.3-57.3 31.6 0 57.3 25.7 57.3 57.3 0 31.6-25.7 57.3-57.3 57.3-31.7 0-57.3-25.7-57.3-57.3zm297.9 0c0-31.6 25.7-57.3 57.3-57.3 31.6 0 57.3 25.7 57.3 57.3 0 31.6-25.7 57.3-57.3 57.3-31.6 0-57.3-25.7-57.3-57.3z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgCurbsideDropoff, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;